import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "250",
  height: "250",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M3.46,15.87c.21,1.18.53,2.44.81,3.49a.31.31,0,0,0,.6-.13c-.1-.65-.7-6.44-.48-6.77a1.8,1.8,0,0,1,1-.61C7.13,11.26,8,11.59,7.91,11a.35.35,0,0,0-.37-.31C3.34,11,2.67,11.44,3.46,15.87Z",
        fill: "currentColor",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M14.92,10.52a.31.31,0,0,0,0,.61c.94,0,3.84.17,4.36.95s-.08,5.8-.48,7.41a.34.34,0,0,0,.66.18,29.63,29.63,0,0,0,1-4.74c.09-.85.24-2.82-.28-3.51C19.32,10.22,16.53,10.39,14.92,10.52Z",
        fill: "currentColor",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M21.25,21.18c-.16-.56-1.76-.6-2.15-.48s-.41.65.19.66c.25,0,1,.35,1.27.21a1.72,1.72,0,0,1-.9,1.37c-2.6,0-13.36,0-15.37-.35-.47-.59-.51-1-.45-1.16s.56,0,.89,0c2.91-.23,9.88-.16,12.79-.1a.31.31,0,0,0,0-.61c-2.95-.17-9.92-.52-12.88-.4-.55,0-1.45.05-1.73.45a2.36,2.36,0,0,0,.78,2.86c1.17.73,15.84.27,16.24.11A2.41,2.41,0,0,0,21.25,21.18Z",
        fill: "#86bd4d",
        "fill-rule": "evenodd"
      }),
      _createElementVNode("path", {
        d: "M5.79,8.66c.92.09,3.13-1.32,3.85-2,.21,2.12.84,8.47,1.12,9.31a.31.31,0,0,0,.58-.19c-.33-1.07-.72-8.84-.87-9.88-.1-.76-.88-.67-1.35-.06a7.83,7.83,0,0,1-3,1.76c0,.09,0-1.13,2.14-3.59.8-.92,3.21-3.46,4.11-2.64a20,20,0,0,1,3.78,6,17.42,17.42,0,0,1-3-2.13A.76.76,0,0,0,12.82,5a.55.55,0,0,0-.45.59c.14,1.44.31-1-.86,10.17a.35.35,0,0,0,.69,0c0,.08,1.37-7.07,1.17-9.3.81.67,1.87,1.77,3.12,1.81A.69.69,0,0,0,17.16,8c.3-.68-.37-1.8-.55-2.23A17.88,17.88,0,0,0,13.8,1.24C13.29.66,12.9-.07,11.88,0,9.36.19,3.81,6.59,5.32,8.42A.67.67,0,0,0,5.79,8.66Z",
        fill: "#86bd4d",
        "fill-rule": "evenodd"
      })
    ], -1)
  ])))
}
export default { render: render }